import { useEffect, useState } from "react";
import { apiClient } from "../../lib/api-client";
import { formatDateTimeSaoPaulo } from "../../lib/currency";

interface AuditEvent {
  id: string;
  actor_user_id: string | null;
  tenant_id: string | null;
  resource_type: string;
  resource_id: string | null;
  action: string;
  result: string;
  created_at: string;
}

export function AdminAuditPage() {
  const [events, setEvents] = useState<AuditEvent[]>([]);

  useEffect(() => {
    apiClient.get<{ items: AuditEvent[] }>("/admin/audit").then((data) => setEvents(data.items));
  }, []);

  return (
    <div>
      <h2>Auditoria</h2>
      <div className="card" style={{ overflowX: "auto" }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Quando</th>
              <th>Recurso</th>
              <th>Ação</th>
              <th>Resultado</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event.id}>
                <td>{formatDateTimeSaoPaulo(event.created_at)}</td>
                <td>{event.resource_type}</td>
                <td>{event.action}</td>
                <td>
                  <span className={`status-badge ${event.result === "success" ? "status-badge--paid" : "status-badge--negative"}`}>
                    {event.result}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
